import { render, staticRenderFns } from "./WPButtonFileIcon.vue?vue&type=template&id=163e081c"
import script from "./WPButtonFileIcon.vue?vue&type=script&lang=ts"
export * from "./WPButtonFileIcon.vue?vue&type=script&lang=ts"
import style0 from "./WPButtonFileIcon.vue?vue&type=style&index=0&id=163e081c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports